<section class="header-section">
    <h2>Modificar condición</h2>
    <button mat-icon-button (click)="clickCloseDialog()">
        <mat-icon>close</mat-icon>
    </button>
</section>

<section class="form-body">
    <form [formGroup]="updateConditionGroup" (ngSubmit)="submit()">
        <div class="form-content">
            <mat-form-field>
                <mat-label>Parametro</mat-label>
                <mat-select formControlName="parameter">
                    @for(parameter of parameters; track parameter){
                        <mat-option [value]="parameter.minuteApprovalParameterId">{{parameter.name}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Comparador</mat-label>
                <mat-select formControlName="comparator">
                    <mat-option *ngFor="let comparator of constraintParameter?.allowedComparators|keyvalue"
                    [value]="comparator.key">
                    {{comparator.value}}
                </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Valor</mat-label>
                @if(constraintParameter?.allowedValues.size > 0) {
                    <mat-select formControlName="value">
                        <mat-option *ngFor="let allowedValue of constraintParameter?.allowedValues|keyvalue"
                            [value]="allowedValue.key">
                            {{allowedValue.value}}
                        </mat-option>
                    </mat-select>
                } @else {
                    <input matInput formControlName="value" mask="separator" thousandSeparator=".">
                }
            </mat-form-field>
        </div>
        <div class="form-bottom">
            <button [disabled]="!updateConditionGroup.valid" mat-raised-button color="primary" type="submit">
                Modificar
            </button>
        </div>
    </form>
</section>